import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Link } from "react-router-dom";

const AirClientDetail = ({ customer, onClose }) => {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center px-4 z-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-2xl p-6 relative overflow-y-auto max-h-[90vh]">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-4 text-gray-500 hover:text-red-500 text-xl"
        >
          <FontAwesomeIcon icon={faClose} />
        </button>

        {/* Title */}
        <h2 className="text-xl font-bold mb-4 text-gray-700">
          Air Client Detail
        </h2>

        {/* Info Grid */}
        <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
          <p className="text-gray-600">ID</p>
          <p>{customer.id}</p>

          <p className="text-gray-600">No Akaun</p>
          <p>{customer.accountNumber}</p>

          <p className="text-gray-600">Nama</p>
          <p>{customer.name}</p>

          <p className="text-gray-600">Kod Kawasan</p>
          <p>{customer.areaCode}</p>

          <p className="text-gray-600">Nama Kawasan</p>
          <p>{customer.areaName}</p>

          <p className="text-gray-600">No Unit</p>
          <p>{customer.unitNumber}</p>

          <p className="text-gray-600">No Harta</p>
          <p>{customer.accountNo}</p>

          <p className="text-gray-600">Alamat Unit</p>
          <p>{customer.unitAddress}</p>

          <p className="text-gray-600">Amaun Bayaran</p>
          <p>
            {customer.paymentAmount !== null
              ? `RM ${Number(customer.paymentAmount).toFixed(2)}`
              : "-"}
          </p>

          <p className="text-gray-600">Pusat Kutipan</p>
          <p>{customer.collectionCenter}</p>

          <p className="text-gray-600">No Resit</p>
          <p>{customer.receiptNumber}</p>

          <p className="text-gray-600">Tarikh Resit</p>
          <p>
            {customer.receiptDate && customer.receiptDate !== "1970-01-01"
              ? new Date(customer.receiptDate).toLocaleDateString()
              : "-"}
          </p>

          <p className="text-gray-600">Status</p>
          <p
            className={`font-semibold ${
              customer.status?.toLowerCase() === "aktif"
                ? "text-green-600"
                : "text-red-600"
            }`}
          >
            {customer.status}
          </p>

          <p className="text-gray-600">Dicipta Pada</p>
          <p>{new Date(customer.createdAt).toLocaleString()}</p>

          <p className="text-gray-600">Dikemaskini Pada</p>
          <p>{new Date(customer.updatedAt).toLocaleString()}</p>
        </div>
          <Link to={`/air-client-update/${customer.id}`} className="  w-full">
          <button className="py-2 mt-3 px-3 w-full rounded-lg bg-yellow-600 text-white">Edit</button>
          </Link>
      </div>
    </div>
  );
};

export default AirClientDetail;
